export default {
  ALL: 'all',
  OPEN: 'registration_open',
  REGISTERED: 'my_registrations',
  PAST: 'past_events',
  UPCOMING: 'upcoming_events',
  LOTTERY: 'lottery_events',
}
